import {
	Backdrop,
	Box,
	CircularProgress,
	Typography,
	Button,
	Divider,
} from "@mui/material";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import EditIcon from "@mui/icons-material/Edit";
import CommentIcon from "@mui/icons-material/Comment";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import React from "react";
import { useState } from "react";
import Message from "../Message";
import { useDispatch, useSelector } from "react-redux";
import { getUserCountries, resetAllStates, setPGState } from "./productGroupSetupSlice";
import SearchPG from "./edit/SearchPG";
import CreatePG from "./create/CreatePG";
import SelectSKU from "./SelectSKU";
import FileUpload from "./FileUpload";
import Attachments from "./Attachments";
import Comments from "./Comments";
import Summary from "./Summary";
import { useEffect } from "react";
import CreateSelectSKU from "./create/CreateSelectSKU";
import CreateFileUpload from "./create/CreateFileUpload";
import CreateAttachments from "./create/CreateAttachments";
import CreateComments from "./create/CreateComments";
import CreateSummary from "./create/CreateSummary";
import CreateMessage from "./create/CreateMessage";
import EditMessage from "./edit/EditMessage";
import CollapseSection from "../../../components/ui/CollapseSection";

export default function ProductGroupSetup() {
	const pgState = useSelector((store) => store.productGroupSetup);
	const { isEdit, isLoading, countries } = pgState;
	const dispatch = useDispatch();

	useEffect(() => {
      if (countries.length === 0) {
         dispatch(getUserCountries());
		}
      dispatch(resetAllStates({ edit: true }));
	}, []);

	function changeScreen() {
		dispatch(setPGState("isEdit", !isEdit));
      dispatch(resetAllStates({ edit: false }));
	}

	const [messageState, setMessageState] = useState({
		message: "",
		severity: "",
		messageOpen: false,
	});
	return (
		<Box sx={{ p: 1, width: "100%" }}>
			{/* LOADING SCREEN */}
			<Box>
				<Backdrop
					sx={{
						color: "#fff",
						zIndex: (theme) => theme.zIndex.drawer + 1,
					}}
					open={isLoading}
				>
					<CircularProgress />
				</Backdrop>
			</Box>

			{/* MESSAGE, INFO, ERROR, SUCCESS */}

			<Box>{isEdit ? <EditMessage /> : <CreateMessage />}</Box>

			{/* SEARCH FOR PRODUCT GROUP / CREATE PRODUCT GROUP LABEL
            CREATE PRODUCT GROUP / EDIT PRODUCT GROUP BUTTON */}
			<Box
				sx={{
					display: "flex",
					flexDirection: "row",
					justifyContent: "space-between",
					marginTop: 2,
				}}
			>
				<Typography variant="subtitle1" color="black.main" >
					{isEdit ? "Search for Product Group" : "Create Product Group"}
				</Typography>
				<Button
					startIcon={isEdit ? <NoteAddIcon /> : <EditIcon />}
					sx={{
						bgcolor: "blue.main",
						color: "white.main",
						textTransform: "none",
						"&:hover": {
							bgcolor: "lightBlue.main",
						},
					}}
					onClick={changeScreen}
				>
					{isEdit ? "Create Product Group" : "Edit Product Group"}
				</Button>
			</Box>

			{/* SEARCH FOR CUSTOMER GROUP / CREATE CUSTOMER GROUP */}
			{isEdit ? <SearchPG /> : <CreatePG />}

			{/* SELECT SKU */}
			{isEdit ? <SelectSKU /> : <CreateSelectSKU />}

			{/* COMMENTS AND ATTACHMENTS LABEL */}
			{/* <Box sx={{ mt: 4, display: "flex", flexDirection: "row" }}>
				<Typography className="compHeading" sx={{fontWeight: "bold", color: "blue.main", width: "100%" }}>
				<AttachFileIcon sx={{ color: "blue.main", mr: 1, width: 22, transform:"translate(0px, 6px)",}} />
					Attachments
				</Typography>
			</Box> */}
			<CollapseSection title="Attachments">
				{/* FILE UPLOAD */}
				{isEdit ? <FileUpload /> : <CreateFileUpload />}

				{/* ATTACHMENTS */}
				{isEdit ? <Attachments /> : <CreateAttachments />}
			</CollapseSection>
			<CollapseSection title="Comments">
				{/* COMMENTS */}
				{isEdit ? <Comments /> : <CreateComments />}
			</CollapseSection>
			{/* SUMMARY */}
			{isEdit ? <Summary /> : <CreateSummary />}
		</Box>
	);
}
